import { userQueryKey } from 'state/queryKeyUtils';

export const userPrefQueryKeys = {
  all: [{ scope: 'userPref' }] as const,
  myUserPrefs: (userId?: number) =>
    [{ ...userPrefQueryKeys.all[0], ...userQueryKey(userId) }] as const,
};
